import { combineReducers } from 'redux';
import Immutable from 'immutable';
import client from './client';
import suggestedResponses from './suggested-responses';
import currentMessage from './current-message';
import messageLoader from './message-loader';
import messages from './messages';
import pageState from './page-state';
import chatter from './chatter';

const rootReducer = combineReducers({
    client,
    messages,
    currentMessage,
    suggestedResponses,
    messageLoader,
    pageState,
    chatter
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js